import { render, staticRenderFns } from "./PaginationButtons.vue?vue&type=template&id=20396972&scoped=true&"
import script from "./PaginationButtons.vue?vue&type=script&lang=js&"
export * from "./PaginationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20396972",
  null
  
)

export default component.exports